"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDepGraph = void 0;
const dep_graph_1 = require("@snyk/dep-graph");
const dependency_1 = require("./dependency");
function buildDepGraph(mavenGraph) {
    const { rootId, nodes } = mavenGraph;
    const root = getPkgInfo(rootId);
    const builder = new dep_graph_1.DepGraphBuilder({ name: 'maven' }, root);
    const visited = [];
    const queue = [];
    queue.push(...getItems(rootId, nodes[rootId]));
    // breadth first search
    while (queue.length > 0) {
        const item = queue.shift();
        if (!item)
            continue;
        const { id, parentId } = item;
        const pkgInfo = getPkgInfo(id);
        if (visited.includes(id)) {
            const prunedId = id + ':pruned';
            builder.addPkgNode(pkgInfo, prunedId, { labels: { pruned: 'true' } });
            builder.connectDep(parentId, prunedId);
            continue; // don't queue any more children
        }
        const parentNodeId = parentId === rootId ? builder.rootNodeId : parentId;
        builder.addPkgNode(pkgInfo, id);
        builder.connectDep(parentNodeId, id);
        queue.push(...getItems(id, nodes[id]));
        visited.push(id);
    }
    return builder.build();
}
exports.buildDepGraph = buildDepGraph;
function getItems(parentId, node) {
    const items = [];
    for (const id of (node === null || node === void 0 ? void 0 : node.dependsOn) || []) {
        items.push({ id, parentId });
    }
    return items;
}
function getPkgInfo(value) {
    const { groupId, artifactId, version } = (0, dependency_1.parseDependency)(value);
    return {
        name: `${groupId}:${artifactId}`,
        version,
    };
}
//# sourceMappingURL=dep-graph.js.map